import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import cx from 'classnames';
import styles from './Header.css';
import appStyles from '../../styles/app.css';
import Navigation from '../../Components/Navigation';
import { isAuthenticated } from '../../redux/auth';
import { COUNSELOR_VIEW } from '../../redux/app';
import SITE_MODES from '../../../constants/site-modes';
import Logo from '../Logo';

const getHREF = pathname => (
  pathname.indexOf('career-matches') !== -1 ? '#career-matches' : '#main_content'
);

const Header = ({
  loggedIn,
  location,
  largeHeader,
  companyName,
  isMobile,
  isTablet,
}) => (
  <header
    tabIndex="0"
    className={styles.wrap}
  >
    <a
      id="skip-to-content"
      href={getHREF(location.pathname)}
      className={appStyles.skipTo}
    >
            Skip to main content
    </a>
    <div
      className={cx(styles.container, {
        [styles.largeHeader]: largeHeader,
        [styles.containerMobile]: isMobile,
      })}
    >
      {!loggedIn ? (
        <Link
          to={'/'}
          aria-label={companyName}
        >
          <Logo className={styles.logo} />
        </Link>
      ) : null}
      {loggedIn ?
        (
          <Navigation
            location={location}
            companyName={companyName}
            isMobile={isMobile}
            isTablet={isTablet}
          />
        )
        : null}
    </div>
  </header>
);


Header.propTypes = {
  loggedIn: PropTypes.bool,
  largeHeader: PropTypes.bool,
  location: PropTypes.object,
  companyName: PropTypes.string,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
};

export default compose(
  withRouter,
  connect(({ auth, theme, app, windowState }) => ({
    loggedIn: isAuthenticated(auth),
    largeHeader: (
      theme.siteMode === SITE_MODES.EMPLOYER &&
            app.view === COUNSELOR_VIEW
    ),
    companyName: theme.companyName,
    companyDomain: theme.companyDomain,
    isMobile: windowState.isMobile,
    isTablet: windowState.isTablet,
  })),
)(Header);



// WEBPACK FOOTER //
// ./src/client/Components/Header/Header.js